export default __webpack_public_path__ + "static/office-ff0adf0f0868f29079ffff7820f9b83a.webp";